<template>
  <div>
    <div class="page-bg">
      <div class="phone-frame">
        <div class="campaign_rulesBtn" @click="showRulesPopup">
          <span>Rules</span>
          <img :src='rules_icon' class="rulesIcon" alt="" />
        </div>
        <img :src='campaign_topBanner_image' alt="" />
        <div class="position-relative neon-slab pb-3 pt-0 px-2 p-md-4">
          <div class="campaign_mainBox">
            <img :src='timer_boxBG' class="campaign_mainBox_image" alt="" />
            <div class="date-box">
              <button class="btn btn-sm compaignPreviousIcon" :disabled="disablePrev" @click="prevDay"
                aria-label="Previous day"><img :src='compaignPrevious' alt="Previous" /></button>
              <strong> {{ dateLabel }}</strong>
              <button class="btn btn-sm compaignNextIcon" :disabled="disableNext" @click="nextDay"
                aria-label="Next day"><img :src='compaignNext' alt="Next" /></button>
            </div>
            <div class="timerTitle_time text-center">
              <div class="sub-orange">All game consumption</div>
              <div class="time_counterDown" v-if="showCountdown">{{ hhmmss }}</div>
            </div>
            <div class="animateCounter-box">
              <div class="counter-display bold">{{ formattedTotal }}</div>
            </div>
          </div>
          <div class="text-center infoText text-white mt-2">
            <!-- <div class="mt-2">
              Statistics of all games ?
            </div> -->
            <div>
              The number of Diamonds bet by all users today, TOP5 users can share the diamonds in proportion.
            </div>
           
          </div>
          <div class="divider-soft my-2">
            <img :src='divider_image' alt="" />
          </div>

          <!-- LOADING / ERROR / EMPTY -->
          <div v-if="loading" class="text-center text-info my-2">
            <div class="spinner-border spinner-border-sm me-2" role="status"></div>
            Loading leaderboard…
          </div>
          <div v-else-if="error" class="alert alert-danger py-1 px-2 small">{{ error }}</div>
          <div v-else-if="!leaderboard.length" class="text-center ">No records found.</div>

          <!-- LEADERBOARD LIST (2..10) -->
          <div class="lb-list mt-3">
            <div v-for="(user, idx) in topSix" :key="user.id"
              class="lb-item d-flex align-items-center justify-content-between px-2 py-3 mb-2"
              :class="{ 'lb-item_1': idx === 0, 'lb-item_2': idx === 1, 'lb-item_3': idx === 2, 'lb-item_4': idx === 3 }">
              <div class="d-flex align-items-center gap-1 campain_userBox">
                <div class="rank-badges">{{ idx + 1 }}</div>
                <div class="campain_userInfoBox">
                  <div class="campain_profileImageBox">
                    <img :src="user.avatar" :alt="user.name" />
                  </div>
                  <div class="campain_userOtherInfoBox">
                    <div class="campain_userName fw-bold">{{ user?.name }}</div>
                    <div class="small">Betting: {{ formatNumber(user.bet) }}</div>
                    <div class="small award-text">
                      ({{ user.percent }}% × All game consumption)
                    </div>
                    <div class="campainRewards_box">
                      <img :src='diamond_icon' class="diamondIcon" alt="" />
                      <span class="rewards_valBox">{{ user.award }}</span>
                      <span class="rewards_title">Reward</span>
                    </div>
                    <!-- <div class="small">• Award‑winning users entry (1 Day)</div> -->
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- BOTTOM BAR -->
          <div class="others_ranksBox px-2 py-3 mb-2 d-flex align-items-center justify-content-between"
            v-for="(user, i) in bottomRest" :key="user.id ?? ('rest-' + i)">
            <div class="d-flex align-items-center gap-1 campain_userBox">
              <div class="rank-badges">{{ i + topSix.length + 1 }}</div>
              <div class="campain_userInfoBox">
                <div class="campain_profileImageBox">
                  <img :src="user.avatar" :alt="user.name" />
                </div>
                <div class="campain_userOtherInfoBox">
                  <div class="campain_userName fw-semibold">{{ user.name }}</div>
                  <div class="small">Betting: {{ formatNumber(user.bet) }}</div>

                  <div class="small award-text" v-if="user.award>0">
                    ({{ user.percent }}% × All game consumption)
                  </div>
                  <div class="campainRewards_box" v-if="user.award>0">
                    <img :src='diamond_icon' class="diamondIcon" alt="" />
                    <span class="rewards_valBox">{{ user.award }}</span>
                    <span class="rewards_title">Reward</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Info Popup Start  -->
    <div class="mode-area" v-show="isPopupOverlayVisible" @click="showRulesPopup"></div>
    <div id="rulesPopup"
      :class="{ 'compaignRule_popup popup_box': true, 'rule-pop-up': true, 'transform-in': rulesPopupVisible, 'transform-out': !rulesPopupVisible }">
      <!-- <img :src='rules_popup_bg' class="rulespopup_bg" alt="" /> -->
      <div class="rulePopup-topHD">Rules</div>
      <div class="rule-popupBody">
        <div class="rule-content">
          <div class="rule-secHd">Reward</div>
          <div class="divider-soft">
            <img :src='divider_image' alt="" />
          </div>
          <div class="rule-secCont">
            <h2 class="mb-0 mt-2 mb-2 d-flex align-items-center gap-2 rules_list_hd">
              <img :src='rule_caretIcon' class="rules_caretIcon" alt="" />
              <span>Overall ranking</span>
            </h2>
            <p>The top 5 users can receive diamonds in proportion to the prize pool, To win the prize, the user must bet
              on all games to reach 50,00,000</p>
            <h2 class="mb-0 mt-2 mb-2 d-flex align-items-center gap-2 rules_list_hd">
              <img :src='rule_caretIcon' class="rules_caretIcon" alt="" />
              <span>Event exposure</span>
            </h2>
            <p>1. All rewards will be issued immediately after the list is settled, at the latest within one working
              day.</p>
            <p>2. Abnormal devices will not be able to participate in this event, and the platform is eligible to
              recover the rewards that have been obtained.</p>
          </div>
          <div class="rule-secHd">Ranking Statistics Game</div>
          <div class="divider-soft">
            <img :src='divider_image' alt="" />
          </div>
          <div class="rule-secCont mt-2">
            <p>Count Diamonds bet on all games, excluding Car Race.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import './GameCompaign.css'
import campaign_topBanner_image from '../../assets/images/campaign/campaign_topBanner_image.webp'
import timer_boxBG from '../../assets/images/campaign/timer_boxBG.webp'
import timer_boxBG_2 from '../../assets/images/campaign/timer_boxBG-2.webp'
import divider_image from '../../assets/images/campaign/divider_image.svg'
import compaignNext from '../../assets/images/campaign/campaign_nextIcon.svg'
import compaignPrevious from '../../assets/images/campaign/campaign_previousIcon.svg'
import rules_icon from '../../assets/images/campaign/rules_icon.webp'
import rules_popup_bg from '../../assets/images/campaign/rules_popup_bg.webp'
import rule_caretIcon from '../../assets/images/campaign/rule_caretIcon.webp'
import diamond_icon from '../../assets/images/diamond-icon.png'
import default_profile from '../../assets/images/default_profile.webp'
 
const API_URL = 'api/top-user-game-ranking-list'
 
export default {
  data () {
    return {
      // assets
      campaign_topBanner_image,
      timer_boxBG,
      divider_image,
      compaignNext,
      compaignPrevious,
      rules_icon,
      timer_boxBG_2,
      rules_popup_bg,
      rule_caretIcon,
      diamond_icon,
      default_profile,
 
      // ui state
      rulesPopupVisible: false,
      isPopupOverlayVisible: false,
      loading: false,
      loadingList: false,
      error: '',
 
      // timers
      nowTs: Date.now(),
      tickTimer: null,
      totalsTimer: null,
      pollBusy: false,
      dayCache: Object.create(null),
      raf: null,
 
      // route/auth
      token: '',
 
      // logic state
      selectedDate: new Date(),
      today: new Date(),
      leaderboard: [],
      state: {
        totalDisplay: 0,
        totalsByType: {},
      }
    }
  },
 
  computed: {
    AUTH_HEADER () {
      if (!this.token) return undefined
      return this.token.startsWith('Bearer ') ? this.token : `Bearer ${decodeURIComponent(this.token)}`
    },
    dateLabel () {
      const d = this.selectedDate
      return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`
    },
    formattedTotal () {
      return this.formatNumber(this.state.totalDisplay)
    },
    // use the actual current date for "today"
    apiType () {
      const a = new Date(this.selectedDate); a.setHours(0,0,0,0)
      const b = new Date();                  b.setHours(0,0,0,0) // today = now
      const diff = Math.floor((b - a) / 86400000)
      if (diff < 0) return 0
      if (diff > 6) return 6
      return diff
    },
    showCountdown () {
      return this.apiType === 0
    },
      remainingSecondsToday () {
      if (!this.showCountdown) return 0
      const now = new Date(this.nowTs)
      const end = new Date(this.nowTs); end.setHours(23,59,59,999)
      return Math.max(0, Math.floor((end - now) / 1000))
    },
    hhmmss () {
    const secs = this.remainingSecondsToday
    const h = String(Math.floor(secs / 3600)).padStart(2, '0')
    const m = String(Math.floor((secs % 3600) / 60)).padStart(2, '0')
    const s = String(secs % 60).padStart(2, '0')
    return `${h}:${m}:${s}`
    },
    disablePrev () { return this.apiType >= 6 },
    disableNext () { return this.apiType <= 0 },
    topSix () { return (this.leaderboard || []).slice(0, 5) },
    bottomRest () { return (this.leaderboard || []).slice(5) }
  },
 
watch: {
  apiType: {
    immediate: false,
    async handler (newType) {
      // stop polling if leaving today
      if (this.totalsTimer && newType !== 0) {
        clearInterval(this.totalsTimer)
        this.totalsTimer = null
      }
 
      // one-shot fetch on day change (single API call for both pieces)
      this.loadingList = true
      try {
        await this.loadAll(newType, { animateTotals: newType === 0 })
      } finally {
        this.loadingList = false
      }
 
      // (re)start 5s poll only for today
      if (newType === 0 && !this.totalsTimer) {
        this.totalsTimer = setInterval(async () => {
          if (this.pollBusy || this.apiType !== 0) return
          this.pollBusy = true
          try {
            await this.loadAll(0, { animateTotals: true })
          } finally {
            this.pollBusy = false
          }
        }, 5000)
      }
    }
  }
},
 
async mounted () {
  this.token = String((this.$route.query.token ?? this.$route.params.token ?? '')).trim()
 
  // live clock for countdown
  this.tickTimer = setInterval(() => { this.nowTs = Date.now() }, 1000)
 
  this.loading = true
  try {
    await this.loadAll(this.apiType, { animateTotals: this.apiType === 0 })
  } finally {
    this.loading = false
  }
 
  // start polling only for today
  if (this.apiType === 0) {
    this.totalsTimer = setInterval(async () => {
      if (this.pollBusy || this.apiType !== 0) return
      this.pollBusy = true
      try {
        await this.loadAll(0, { animateTotals: true })
      } finally {
        this.pollBusy = false
      }
    }, 5000)
  }
},
 
beforeUnmount () {
  if (this.tickTimer) clearInterval(this.tickTimer)
  if (this.totalsTimer) clearInterval(this.totalsTimer)
  if (this.raf) cancelAnimationFrame(this.raf)
},
 
  methods: {
    // UI
    showRulesPopup () {
      this.rulesPopupVisible = !this.rulesPopupVisible
      this.isPopupOverlayVisible = !this.isPopupOverlayVisible;
    },
 
    // date controls
    prevDay () {
      if (this.disablePrev) return
      const d = new Date(this.selectedDate)
      d.setDate(d.getDate() - 1)
      this.selectedDate = d
    },
    nextDay () {
      if (this.disableNext) return
      const d = new Date(this.selectedDate)
      d.setDate(d.getDate() + 1)
      this.selectedDate = d
    },
 
  // API calls
 async loadAll (type, { animateTotals = false } = {}) {
    this.error = ''
    try {
      // if past day and we have a cached leaderboard, show it immediately
      if (type !== 0 && this.dayCache[type]) {
        this.leaderboard = this.dayCache[type]
      }
 
      const { data } = await axios.get(`${API_URL}?type=${encodeURIComponent(type)}`, {
        headers: {
          Accept: 'application/json',
          ...(this.AUTH_HEADER ? { Authorization: this.AUTH_HEADER } : {})
        }
      })
 
      // parse leaderboard
      const rows = Array.isArray(data?.result?.data) ? data.result.data : []
      const mapped = rows.map((r, i) => this.mapRow(r, i))
                         .filter(Boolean)
                         .sort((a, b) => (b.bet || 0) - (a.bet || 0))
      this.leaderboard = mapped
      if (type !== 0) this.dayCache[type] = mapped // cache past day list
 
      // parse total
      const total = Number(data?.result?.all_game_bet)
      if (Number.isFinite(total)) {
        if (animateTotals && type === 0) {
          const prev = Number.isFinite(this.state.totalsByType[0])
            ? this.state.totalsByType[0]
            : this.state.totalDisplay
          const from = Number.isFinite(prev) ? prev : this.state.totalDisplay
          const to = total
          if (Number.isFinite(from) && to !== from) {
            this.animateTotal(from, to, 1600)
          } else {
            this.state.totalDisplay = to
          }
          this.state.totalsByType[0] = total
        } else {
          // past days or no animation
          this.state.totalDisplay = total
          this.state.totalsByType[type] = total
        }
      }
    } catch (e) {
      console.error(e)
      this.error = 'Failed to load data.'
    }
  },
 
  // helpers
  animateTotal (from, to, duration = 1800) {
  from = Number(from) || 0; to = Number(to) || 0
  const start = performance.now()
  const delta = to - from
  const ease = t => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t)
 
  if (this.raf) cancelAnimationFrame(this.raf) // cancel running anim
 
  const step = now => {
    const t = Math.min(1, (now - start) / duration)
    this.state.totalDisplay = Math.round(from + delta * ease(t))
    if (t < 1) {
      this.raf = requestAnimationFrame(step)
    } else {
      this.raf = null
      this.state.totalDisplay = to
    }
  }
 
  this.raf = requestAnimationFrame(step)
},
 
    toNum (x) { const n = Number(x); return Number.isFinite(n) ? n : 0 },
    mapRow (r, i) {
      return {
        id: r.id ?? r.user_id ?? r.uid ?? i,
        name: r?.user?.name ?? `User ${i + 1}`,
        avatar: r?.user?.profile_images?.[0]?.image_name || default_profile,
        bet: this.toNum(r.total_bets),
        award: this.toNum(r.reward_coin),
        percent: this.toNum(r.reward_per)
      }
    },
    formatNumber (n) { return Number(n ?? 0).toLocaleString() }
  }
}
 
</script>